import React, { useState, useEffect } from 'react';
import { 
    Table, TableBody, TableCell, TableContainer, TableRow, Paper, 
    TableHead, Button, TablePagination, TextField, Dialog, 
    DialogActions, DialogContent, DialogContentText, DialogTitle 
} from '@mui/material';
import AddAreaEncuesta from './AddAreaEncuesta';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';

function GestionAreaEncuesta() {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [areasEncuesta, setAreasEncuesta] = useState([]);
    const [editAreaEncuesta, setEditAreaEncuesta] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [areaEncuestaToDelete, setAreaEncuestaToDelete] = useState(null);
    const { user } = useUser();
    const { tienePermiso } = useAccesos();

    const fetchAreasEncuesta = async () => {
            try {
                const response = await fetch(`${server}/CrmAreaEncuestums`);
                const data = await response.json();
                setAreasEncuesta(data.$values);
                console.log("Respuesta de la API:", data);
            } catch (error) {
                console.error('Error al cargar las Áreas de encuestas:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al cargar las Áreas de encuestas: ' + error,
                });
            }
        };


        
            useEffect(() => {
                fetchAreasEncuesta();
            }, []);
        
            const handleNewAreaEncuesta= () => {
                fetchAreasEncuesta();
                setEditAreaEncuesta(null);
            };
        
            const handleChangePage = (event, newPage) => {
                setPage(newPage);
            };
        
            const handleChangeRowsPerPage = (event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
            };
        
            const handleSearchChange = (event) => {
                setSearchQuery(event.target.value);
            };
        
            const handleOpenDialog = (areaEncuesta) => {
                setAreaEncuestaToDelete(areaEncuesta);
                setOpenDialog(true);
            };
        
            const handleCloseDialog = () => {
                setOpenDialog(false);
                setAreaEncuestaToDelete(null);
            };
        
            const handleDeleteAreaEncuesta = async () => {
                if (areaEncuestaToDelete) {
                    try {
                        const username = ''+user.codigoUsuario+'/';
        
                        const response = await fetch(`${server}/CrmAreaEncuestums/${areaEncuestaToDelete.id}/${username}`, {
                            method: 'DELETE'
                        });

                        if (response.ok) {
                            handleCloseDialog();
                            fetchAreasEncuesta();
                            Swal.fire({
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Área encuesta eliminada con éxito',
                            });
                        } else {
                            handleCloseDialog();
        
                            const errorData = await response.json();
                            const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                            Swal.fire({
                                icon: 'error',
                                title: `Error ${response.status}`,
                                text: errorMessage,
                            });
                        }
                    } catch (error) {
                        console.error('Error al eliminar el área encuesta:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al eliminar el área encuesta: ' + error,
                        });            }
                }
            };
        
            const filteredAreaEncuesta = areasEncuesta.filter(areaEncuesta => areaEncuesta.areaEncuesta?.toLowerCase().includes(searchQuery.toLowerCase()));
    
        const handleCancelarEdicion = () => {
            setEditAreaEncuesta(null);
        }


return (
<>
    <div className="x_title">
        </div>

        <div className="x_content">
            <br />

            <AddAreaEncuesta handleNewAreaEncuesta={handleNewAreaEncuesta} editAreaEncuesta={editAreaEncuesta} cancelarEdicion={handleCancelarEdicion}/>

            <div className="ln_solid" />

            <h2>Áreas de encuesta existentes</h2> 

            <div className="row">
                <div className="col-md-6 col-sm-4 offset-md-3">
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Buscar Área"
                        placeholder="Buscar..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        style={{ marginBottom: '20px' }}
                    />

                    <div className="table-responsive">
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Descripción</TableCell>
                                        <TableCell align="right">Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredAreaEncuesta.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((areaEncuesta) => (
                                            <TableRow key={areaEncuesta.id}>
                                                <TableCell component="th" scope="row">
                                                    {areaEncuesta.areaEncuesta}
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Button onClick={() => setEditAreaEncuesta(areaEncuesta)} color="primary" disabled={!tienePermiso('Editar Área Encuesta')}>
                                                        Editar
                                                    </Button>
                                                    <Button onClick={() => handleOpenDialog(areaEncuesta)} color="secondary" disabled={!tienePermiso('Eliminar Área Encuesta')}>
                                                        Eliminar
                                                    </Button>
                                                </TableCell>
                                            </TableRow>                                        
                                    ))}

                                   
                                </TableBody>
                            </Table>

                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={filteredAreaEncuesta.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelRowsPerPage="Filas por página:"
                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                            />
                        </TableContainer>

                        <Dialog open={openDialog}
                         onClose={handleCloseDialog}
                         aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description">
                            
                            <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    ¿Estás seguro de que quieres eliminar esta área de encuesta?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button  onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                <Button onClick={handleDeleteAreaEncuesta} color="primary" autoFocus>Eliminar</Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                </div>
            </div>
        </div>
    </>

     
    );
}

export default GestionAreaEncuesta;